module.exports = __webpack_public_path__ + "media/images/mastercard-8344e47d6079a6c1c850074e61c96d0a.svg";